module.exports = __webpack_public_path__ + "img/help_content1.f29c7e5a.png";